// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthData, AuthState } from "../../utils/types";

const initialState: AuthState = {
  userInfo: null, // for user object
  idToken: null, // for storing the JWT
  decodedIdToken: null, // for storing the decoded JWT
  isAuthenticated: false, // for checking if the user is authenticated
  errorMessage: null,
  status: "idle",
  loading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
      state.loading = false;
    },
    setUserAuthData: (state, action: PayloadAction<AuthData>) => {
      state.userInfo = action.payload.userInfo;
      state.idToken = action.payload.idToken;
      state.decodedIdToken = action.payload.decodedIdToken;
    },
    setStatus: (state, action: PayloadAction<AuthState["status"]>) => {
      state.status = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setIsAuthenticated, setStatus, setUserAuthData, setLoading } =
  authSlice.actions;

export default authSlice.reducer;
